import React from 'react';
import pix from '../Images/welcome.png'
import { Link } from 'react-router-dom';
import Navbar from '../Components/Navbar';
import { useNavigate } from 'react-router-dom';



const Login = () => {

    const navigate = useNavigate();

    const saveItem = () => {
        navigate('/dashboard')
      }


  return (


    <div>
        <Navbar/>
        <section class="login">
            

        <div class="welcome">
            <img src={pix} alt=""/>
        </div>

        <div class="form">

            <form method="get" className='form-c'>
            
                <h2>Welcome Back</h2>
                <p>Please enter your details below</p>
                <label>Email Address</label>
                <input type="email" name="" id="" class="inp"/>

                <label>Password</label>
                <div class="eye">
                    <input type="password" name="" id=""/>
                    <img src="../assets/images/eye1.png" alt=""/>
                </div>

                <div class="password">
                    <div class="rem">
                        <input type="checkbox" name="" id=""/> 
                        <span>Remember me</span>
                    </div>

                    <div class="forgot">
                        <a href="">Forgot Password?</a>
                    </div>

                </div>
                
                <input type="submit" value="Login" class="submit" onClick={saveItem}/>
                <h4>Don’t have an account?  Sign Up as <span><Link to='/talentsignup'>Talent</Link></span> or <span><Link to='/clientsignup'>Client</Link> </span></h4>

            </form>

        </div>


        
    </section>
    </div>
  )
}

export default Login